import { useWeb3React } from "@web3-react/core";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import useAuth from "../hooks/useAuth";
import Loader from "../hooks/loader";
import QRCode from "react-qr-code";
import { useCheckAllowance } from "../hooks/dataSender/Allowance";
import useApprove from "../hooks/dataSender/Approval";
import { useTransfer } from "../hooks/dataFetcher/transfer";
import { toast } from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import { CRASH_GAME_CONTRACT } from "../utils/Enviroment";
import useWithdrawalAmountHook from "../hooks/dataFetcher/withdrawAmount";
import useWeb3 from "../hooks/useWeb3";
import {
  useEthInternalBalace,
  usePermisions,
  usePublicClient,
  userSmartAccount,
  userSmartAccountClient,
  useSmartSession,
} from "./recoilAtom";
import { useRecoilValue } from "recoil";
import backendClient from "../utils/backendClient";
import showToast from "../hooks/showToast";
import { Value } from "sass";

const WithDrawModel = ({
  show1,
  handleClose1,
  userBalance,
  ethInternalBalance,
  onTransactionUpdate,
  bnbPrice,
}) => {
  const ethinternalBlce = useRecoilValue(useEthInternalBalace);
  const publicClient = useRecoilValue(usePublicClient);
  const smartAccount = useRecoilValue(userSmartAccount);
  const meClient = useRecoilValue(userSmartAccountClient);
  const session = useRecoilValue(useSmartSession);
  const permission = useRecoilValue(usePermisions);
  const [show3, setShow3] = useState(false);
  const handleClose3 = () => {
    setShow3(false);
    // window.location.reload();
  };
  const handleShow3 = () => setShow3(true);
  const [errorBool1, setErrorBool1] = useState(false);
  const [addresstrue, setAddressstrue] = useState(false);
  const web3 = useWeb3();
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const { withdrawalAmountTransaction } = useWithdrawalAmountHook();
  const [show6, setShow6] = useState(false);
  const handleClose6 = () => {
    setShow6(false);
    window.location.assign("/myprofile");
  };
  const handleShow6 = () => setShow6(true);
  const [inputAddress, setInputAddress] = useState(null);
  const tokenArry = [
    { simbal: "ETH", image: "/assets/playassets/eth.svg" },
    { simbal: "USDC", image: "/assets/playassets/usdc.svg" },
  ];
  const [selectedToken, setSelectedToken] = useState("ETH");

  // console.log("selectedToken", selectedToken);
  const [selectedImage, setSelectedImage] = useState(
    "/assets/playassets/eth.svg"
  );

  const [errorMessage, setErrorMessage] = useState("");
  const [errorBool, setErrorBool] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loaderText, setLoaderText] = useState({
    heading: "Loading",
    paragraph: "",
  });

  const [isUsdt, setIsUsdt] = useState(false);
  const [withdrawInput, setwithdrawInput] = useState(null);
  let { account } = useWeb3React();
  const withdrawHandler = (e) => {
    setwithdrawInput(e.target.value);
    if (isUsdt) {
      if (+e.target.value > +userBalance) {
        setErrorMessage("Amount must be less than balance");
        setErrorBool(true);
      } else {
        setErrorMessage("");
        setErrorBool(false);
      }
    } else {
      if (+e.target.value > +ethInternalBalance) {
        setErrorMessage("Amount must be less than balance");
        setErrorBool(true);
      } else {
        setErrorMessage("");
        setErrorBool(false);
      }
    }
  };

  //api func
  const withdrawAPI = async (hash) => {
    try {
      const tokenSymbol = isUsdt ? "USDT" : "BNB";
      const payload = {
        withdrawAddress: account,
        amount: withdrawInput,
        token: isUsdt ? "USDT" : "BNB",
        // chain: "BSC", // replace with dynamic chain if needed
        txHash: hash,
        // timestamp: new Date().toISOString(),
      };
      if (tokenSymbol === "BNB" && bnbPrice && withdrawInput) {
        // Calculate the USD value using the passed-in price
        const amountInUSD = parseFloat(withdrawInput) * bnbPrice;
        // Add the new field to the payload
        payload.amountUSD = amountInUSD.toFixed(2);
      }
      await backendClient.post("/transactions/create-withdraw", payload);
      // toast.success("Deposit recorded successfully");
    } catch (err) {
      console.error("Deposit API error:", err);
      toast.error("Withdraw failed.Please try again.");
    }
  };
  const withdrawTransection = async () => {
    setLoading(true);
    try {
      if (isUsdt) {
        let value = await withdrawalAmountTransaction(
          inputAddress,
          withdrawInput,
          isUsdt,
          userBalance,
          ethInternalBalance,
          smartAccount,
          meClient,
          permission,
          session,
          publicClient
        );
        if (value) {
          console.log(value, "value");

          setLoading(false);
          handleShow6();
          handleClose1();
          if (value) {
            await withdrawAPI(value);
          }
          if (typeof onTransactionUpdate === "function") {
            await onTransactionUpdate();
          }
        }
      } else {
        let value = await withdrawalAmountTransaction(
          inputAddress,
          withdrawInput,
          isUsdt,
          userBalance,
          ethInternalBalance,
          smartAccount,
          meClient,
          permission,
          session,
          publicClient
        );
        if (value) {
          console.log(value, "value");
          setLoading(false);
          handleShow6();
          handleClose1();

          if (value) {
            await withdrawAPI(value);
          }
          if (typeof onTransactionUpdate === "function") {
            await onTransactionUpdate();
          }
        }
      }
    } catch (errr) {
      console.log(errr, "withdraw session");
      handleShow2();
      setLoading(false);
    }

    // handleClose1();
  };

  const handlewalletAddress = (e) => {
    setInputAddress(e.target.value);
    const validAddress = web3.utils.isAddress(e.target.value);
    console.log(validAddress, "validAddress");

    if (validAddress) {
      setErrorBool1(true);
      setAddressstrue(validAddress);
    } else {
      setErrorBool1(false);
    }
  };

  const maxHandler = () => {
    // {isUsdt ? (
    //   <>
    //     {Number(userBalance).toLocaleString(undefined, {
    //       minimumFractionDigits: 4,
    //       maximumFractionDigits: 4,
    //     })}
    //   </>
    // ) : (
    //   <>
    //     {Number(ethInternalBalance).toLocaleString(undefined, {
    //       minimumFractionDigits: 5,
    //       maximumFractionDigits: 5,
    //     })}

    if (isUsdt) {
      setwithdrawInput(userBalance);
    } else if (ethInternalBalance > 0.000002) {
      let value = ethInternalBalance - 0.000001;
      setwithdrawInput(value.toFixed(10));
    } else {
      setwithdrawInput(0);
    }
    // {isUsdt ? (
    //   <>
    //     {Number(userBalanceExternal)?.toLocaleString(
    //       undefined,
    //       {
    //         minimumFractionDigits: 4,
    //         maximumFractionDigits: 4,
    //       }
    //     )}
    //   </>
    // ) : (
    //   <>
    //     {Number(ethExternalBalance)?.toLocaleString(undefined, {
    //       minimumFractionDigits: 5,
    //       maximumFractionDigits: 5,
    //     })}
  };

  return (
    <>
      {loading && <Loader text={loaderText} />}
      <Modal className="editmodal" show={show1} onHide={handleClose1} centered>
        <Modal.Header closeButton>
          <Modal.Title>Withdraw</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="upperbox">
            <p>Only send to a USDT address on the Arbitrum network</p>
          </div> */}
          <div className="mainparentinputssss">
            <div className="left">
              <p>Token</p>
              <div class="dropdown dropdowntokenitems">
                <button
                  class="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="left-item">
                    <div className="maintokenimg">
                      <img src={selectedImage} alt="img" className="tokenimg" />
                      <img
                        src="/assets/playassets/base.svg"
                        alt="baseimg"
                        className="baseimg"
                      />
                    </div>
                    {selectedToken}
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M8.60172 15.5855L3.53922 10.523C3.43367 10.4174 3.37437 10.2743 3.37437 10.125C3.37437 9.97573 3.43367 9.83258 3.53922 9.72703C3.64477 9.62148 3.78792 9.56219 3.93719 9.56219C4.08645 9.56219 4.22961 9.62148 4.33516 9.72703L8.43719 13.8298L8.43719 2.8125C8.43719 2.66332 8.49645 2.52024 8.60194 2.41475C8.70743 2.30926 8.8505 2.25 8.99969 2.25C9.14887 2.25 9.29195 2.30926 9.39743 2.41475C9.50292 2.52024 9.56219 2.66332 9.56219 2.8125L9.56219 13.8298L13.6642 9.72703C13.7698 9.62148 13.9129 9.56219 14.0622 9.56219C14.2115 9.56219 14.3546 9.62148 14.4602 9.72703C14.5657 9.83258 14.625 9.97573 14.625 10.125C14.625 10.2743 14.5657 10.4174 14.4602 10.523L9.39766 15.5855C9.34541 15.6378 9.28338 15.6793 9.21509 15.7076C9.1468 15.7359 9.07361 15.7504 8.99969 15.7504C8.92577 15.7504 8.85257 15.7359 8.78428 15.7076C8.716 15.6793 8.65396 15.6378 8.60172 15.5855Z"
                      fill="white"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li>
                    {tokenArry.map((data) => {
                      return (
                        <li>
                          <a
                            class="dropdown-item"
                            onClick={() => {
                              setSelectedImage(data.image);
                              setSelectedToken(data.simbal);
                              setwithdrawInput("");
                              setErrorMessage("");
                              if (data.simbal === "USDC") {
                                setIsUsdt(true);
                              } else {
                                setIsUsdt(false);
                              }
                            }}
                          >
                            <div className="maintokenimg">
                              <img
                                src={data.image}
                                alt="img"
                                className="tokenimg"
                              />
                              <img
                                src="/assets/playassets/base.svg"
                                alt="baseimg"
                                className="baseimg"
                              />
                            </div>
                            {data.simbal}
                          </a>
                        </li>
                      );
                    })}
                  </li>
                </ul>
              </div>
            </div>
            <div className="left">
              <p>Chain</p>
              <div className="innermain">
                <p className="walletpara">Base Mainnet</p>
                <img
                  src="\assets\playassets\base.svg"
                  alt="img"
                  className="img-fluid bsclogo"
                />
              </div>
            </div>
          </div>
          <div className="parentmaininput">
            <div className="innerinputmain">
              <p>Address</p>
              <input
                type="text"
                placeholder="please provide account"
                value={inputAddress}
                onChange={handlewalletAddress}
              />
              {!errorBool1 && inputAddress && (
                <p className="errorpara">please provide correct address</p>
              )}
            </div>
            <div className="innerinputmain">
              <div className="amountparent">
                <p className="amountpara">Amount</p>
                <h6>
                  Balance:{" "}
                  <span>
                    {" "}
                    {isUsdt ? (
                      <>
                        {Number(userBalance).toLocaleString(undefined, {
                          minimumFractionDigits: 4,
                          maximumFractionDigits: 4,
                        })}
                      </>
                    ) : (
                      <>
                        {Number(ethInternalBalance).toLocaleString(undefined, {
                          minimumFractionDigits: 5,
                          maximumFractionDigits: 5,
                        })}
                      </>
                    )}{" "}
                    {selectedToken}
                  </span>
                </h6>
              </div>
              <div className="inputtheter">
                <button className="maxbtn" onClick={maxHandler}>
                  max
                </button>
                <input
                  type="number"
                  className="withdraawinput"
                  placeholder="0.00"
                  value={withdrawInput}
                  onChange={withdrawHandler}
                />
                <div className="maintokenimg">
                  <img
                    src={selectedImage}
                    alt="tokenimg"
                    className="tokenimg"
                  />
                  <img
                    src="/assets/playassets/base.svg"
                    alt="baseimg"
                    className="baseimg"
                  />
                </div>
                {errorBool && <p className="errorpara">{errorMessage}</p>}
              </div>
            </div>
          </div>
          <div className="lastbuttons">
            <button className="cancle" onClick={handleClose1}>
              Close
            </button>
            <button
              className="save"
              disabled={
                !withdrawInput ||
                withdrawInput === 0 ||
                errorBool ||
                !addresstrue
                  ? true
                  : false
              }
              onClick={withdrawTransection}
            >
              Withdraw
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="editmodal" show={show2} onHide={handleClose2} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mainuppercontent">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
              >
                <path
                  d="M25.9997 47.6666C37.9658 47.6666 47.6663 37.9661 47.6663 25.9999C47.6663 14.0337 37.9658 4.33325 25.9997 4.33325C14.0335 4.33325 4.33301 14.0337 4.33301 25.9999C4.33301 37.9661 14.0335 47.6666 25.9997 47.6666Z"
                  stroke="#FF3434"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26 13V26L34.6667 30.3333"
                  stroke="#FF3434"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <h6>Withdrawal Failed</h6>
          </div>
          <p className="mainparamodal">
            There are a lot of withdrawals happening right now and yours was
            unsuccessful due to high congestion. Please try again later or break
            your withdrawal down into smaller chunks of {selectedToken}
          </p>
          <div className="note">
            <p>
              Note: Your {selectedToken} is safe this congestion should subside
              shortly.
            </p>
          </div>
          <button
            className="back"
            onClick={() => {
              // handleShow3();
              handleClose2();
            }}
          >
            Back
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        className="editmodal  liquidity"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mainuppercontent">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="28"
                viewBox="0 0 38 28"
                fill="none"
              >
                <path
                  d="M36.3346 2L12.5013 25.8333L1.66797 15"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <h6>Liquidity Successfully Withdrawn</h6>
          </div>
          <p className="mainparamodal">
            Your funds
            <span>
              {" "}
              ({withdrawInput} {selectedToken})
            </span>{" "}
            were successfully transferred
          </p>

          <button className="back" onClick={handleClose3}>
            Close
          </button>
        </Modal.Body>
      </Modal>
      <Modal className="editmodal" show={show6} onHide={handleClose6} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mainuppercontent">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="28"
                viewBox="0 0 38 28"
                fill="none"
              >
                <path
                  d="M36.3346 2L12.5013 25.8333L1.66797 15"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <h6>Withdraw Completed!</h6>
          </div>
          <p className="mainparamodal">
            <span>
              {withdrawInput} {selectedToken}
            </span>{" "}
            were successfully Withdraw to your account
          </p>

          <button
            onClick={() => {
              window.location.assign("/myprofile");
            }}
            className="back"
          >
            View History
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WithDrawModel;
